module.exports = __webpack_public_path__ + "img/construction-activity.867664b2.jpg";